import { createContext, useContext, useState, useEffect } from 'react';

import { getLeadSource } from '../Api/CRMAPI/leadSource';
import { fetchRawLeads } from '../Api/CRMAPI/rawleads';
import { fetchCRMLeads } from '../Api/CRMAPI/crmleads';

const CRMDataContext = createContext();

export const CRMDataProvider = ({ children }) => {
    const [leadSource, setLeadSource] = useState([]);
    const [rawLeadData, setRawLeadData] = useState([]);
    const [leadData, setLeadData] = useState([]);

    const loadLeadSourceData = async () => {
        try {
            const data = await getLeadSource();
            console.log(data, 'data of body types')
            setLeadSource(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadRawLeadData = async () => {
        try {
            const data = await fetchRawLeads();
            console.log(data, 'data of body types')
            setRawLeadData(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };

    const loadLeadData = async () => {
        try {
            const data = await fetchCRMLeads();
            console.log(data, 'data of body types')
            setLeadData(data);
        } catch (error) {
            console.error('Failed to fetch categories:', error);
        }
    };


    return (
        <CRMDataContext.Provider
            value={{
                leadSource,
                loadLeadSourceData,
                rawLeadData,
                loadRawLeadData,
                leadData,
                loadLeadData
            }}
        >
            {children}
        </CRMDataContext.Provider>
    )

}


export const useCRMDataContext = () => useContext(CRMDataContext);
